import camelCase from 'lodash/camelCase';
import snakeCase from 'lodash/snakeCase';
import config from './config.json';

if (!('services' in window)) {
	window.services = {};
}

/**
 * Create the Federated Module remote endpoint map (`window.services`). This
 * logic handles environment context to determine when remotes should come from
 * environment-specific endpoints, like guildacceptance.com.
 */
(config as MFEConfig).services.forEach(
	({ local: serviceIsLocal = false, port = 8081, service, subdomain }) => {
		const BASE_URL = process.env.GUILD_BASE_URL || 'guildeducation.com';
		const isAcceptance = BASE_URL.includes('guildacceptance.com');
		const hostIsLocal = process.env.NODE_ENV === 'development';

		const envSubdomain = isAcceptance
			? hostIsLocal
				? `${subdomain}-dev`
				: `${subdomain}-staging`
			: subdomain;

		const protocol = `http${serviceIsLocal ? '' : 's'}`;
		const NAME = snakeCase(String(service)).toUpperCase().replace(/\./, '_');
		const ENV_KEY = `GUILD_SERVICE_${NAME}_URL`;

		const serviceKey = subdomain
			? camelCase(String(subdomain))
			: camelCase(`mfe-service-${String(service).toLowerCase()}`);

		const defaultUrl = `${protocol}://${
			serviceIsLocal ? '' : `${envSubdomain}.`
		}${serviceIsLocal ? `localhost:${port}` : BASE_URL}`;

		window.services[serviceKey] = process.env[ENV_KEY] || defaultUrl;
	},
);

import('./app');
